import React, { Fragment, } from "react";
import { Box, Paper, Table, TableContainer, TableCell, TableRow, TableBody,
} from "@mui/material";
import { EnhancedTableHead } from '../../../../components/CustomTable';

const HeadColumn = ({onGetPersonSalesReportListStart, fromDate, toDate, flag,
    personSalesReport: {personSalesReportData, personPageDetails, grandTotalSales,}}) => {

    const [dense, setDense] = React.useState(false);

    type Order = "asc" | "desc";
    const [order, setOrder] = React.useState<Order>("asc");
    const [orderBy, setOrderBy] = React.useState<any>("name");

    interface HeadCell {
        disablePadding: boolean;
        id: any;
        label: string;
        isShow: boolean;
        numeric: boolean;
        align?: string;
    }
    const headCells: readonly HeadCell[] = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "User Name",
            isShow: true,
        },
        {
            id: "total_sales",
            numeric: false,
            disablePadding: true,
            label: "Total Sales",
            isShow: true,
        },
    ]
    const handleRequestSort = (field) => {
        const isAsc = orderBy === field && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(field);
    
        onGetPersonSalesReportListStart(fromDate, toDate, personPageDetails?.page, personPageDetails?.limit, isAsc ? "asc" : "desc", field, flag);
    };
    return(
        <Fragment>
            <Box sx={{ overflow: "auto" }}>
                <Box sx={{ width: "100%", display: "table", tableLayout: "fixed" }}>
                    <TableContainer component={Paper}>
                        <Table aria-labelledby="tableTitle" size={dense ? "small" : "medium"}>
                            <EnhancedTableHead
                                numSelected={0}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={() => {}}
                                onRequestSort={(event, property) => handleRequestSort(property)}
                                rowCount={personSalesReportData?.length}
                                headCells={headCells}
                                isCheckBox = {false}
                            />
                            <TableBody>
                                {personSalesReportData && personSalesReportData?.length > 0 ? (
                                    personSalesReportData?.map((row, index) => {
                                        return(
                                            <TableRow key={index}>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    whiteSpace: "nowrap", width: "100%",
                                                    height: "75px",
                                                }}>
                                                  {row?.name ? row?.name : "-"}
                                                </TableCell>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    whiteSpace: "nowrap", width: "100%",
                                                }}>
                                                  {row?.total_sales != undefined ? row?.total_sales.toFixed(2) : "0.00"}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={headCells.length} align="center">
                                            No Data Available
                                        </TableCell>
                                    </TableRow>
                                )

                                }
                            </TableBody>
                            <TableCell
                                key="totalSale"
                                align="center"
                                sx={{
                                    borderTop: "1px solid #ebeded",
                                    borderRight: "1px solid #ebeded",
                                    borderLeft: "1px solid #ebeded",
                                    // height: "75px",
                                    fontWeight: "bold", 
                                }}
                            >
                                Total Sale
                            </TableCell>
                            <TableCell
                                key="totalSale"
                                align="center"
                                sx={{
                                    borderTop: "1px solid #ebeded",
                                    borderRight: "1px solid #ebeded",
                                    borderLeft: "1px solid #ebeded",
                                    // height: "75px",
                                    fontWeight: "bold", 
                                }}
                            >
                                {grandTotalSales != undefined ? grandTotalSales.toFixed(2) : "0.00"}
                            </TableCell>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Fragment>
    )
}

export default HeadColumn;